import { useContext } from 'react';

// import { isMobile } from 'react-device-detect';
import { AppContext } from '../../../contexts/app-context';
import { clearLocalStorage, goToRoutePage } from '../../../utils/helper';
import {
  AutorenewToneIcon, ContractOrderIcon, DarkThemeOffIcon, DarkThemeOnIcon, HomeIcon, JobIcon,
  ManageSettingsIcon, OnboardingIcon, OptoutIcon, OrderIcon, PendingEnrollmentIcon, PreorderIcon,
  ReplacementIcon, SavesIcon, SubscriptionIcon, UploadIcon, ValidationIcon
} from '../../../utils/icons';
import {
  Divider, List, ListItem, ListItemIcon, ListItemText
} from '../../../utils/material-ui-core';

interface IMenuList {
  callbackToggleDarkTheme: () => void;
}
const MenuList = ({ callbackToggleDarkTheme }: IMenuList) => {
  const { themeType, appRoutePaths } = useContext(AppContext);

  const getAppAccessItemIcon = (title: string) => {
    if (title === "Onboarding") return <OnboardingIcon />;
    else if (title === "Subscription") return <SubscriptionIcon />;
    else if (title === "Replacement") return <ReplacementIcon />;
    else if (title === "Manual Orders") return <OrderIcon />;
    else if (title === "Jobs & Log") return <JobIcon />;
    else if (title === "Validation") return <ValidationIcon />;
    else if (title === "Manage Settings") return <ManageSettingsIcon color="primary" />;
    else if (title === "Enlistment Reviews") return <PendingEnrollmentIcon />;
    else if (title === "Enrollment Correction") return <PendingEnrollmentIcon />;
    else if (title === "Upload Enrollment File") return <UploadIcon />;
    else if (title === "Saves") return <SavesIcon />;
    else if (title === "Contract Orders") return <ContractOrderIcon />;
    else if (title === "Preorder Corrections") return <PreorderIcon />;
    else if (title === "Account Optout") return <OptoutIcon />;

    return <OnboardingIcon />;
  };

  return (
    <List>
      <ListItem></ListItem>
      {/* {
        ((String(window.location.pathname) !== '/' &&
          String(window.location.pathname).toLowerCase().indexOf("homex") === -1) ||
          isMobile) ?
          <> */}
      <ListItem button onClick={() => goToRoutePage("home")}>
        <ListItemIcon>
          <HomeIcon color="secondary" />
        </ListItemIcon>
        <ListItemText primary="Home" />
      </ListItem>

      {appRoutePaths.map((item, index) => (
        <ListItem button key={index} onClick={() => goToRoutePage(item.path)}>
          <ListItemIcon>{getAppAccessItemIcon(item.title)}</ListItemIcon>
          <ListItemText primary={item.title} />
        </ListItem>
      ))}
      <ListItem></ListItem>
      <Divider />
      {/* </>
      //     : null
      // } */}
      <ListItem></ListItem>
      <ListItem button onClick={() => callbackToggleDarkTheme()}>
        <ListItemIcon>{themeType === "dark" ? <DarkThemeOnIcon /> : <DarkThemeOffIcon />}</ListItemIcon>
        <ListItemText primary={"Toggle Light/Dark Mode"} />
      </ListItem>
      <ListItem button onClick={() => clearLocalStorage("", true)}>
        <ListItemIcon>
          <AutorenewToneIcon />
        </ListItemIcon>
        <ListItemText primary={"Clear Local Cache"} />
      </ListItem>
    </List>
  );
};

export default MenuList;
